module.exports = __webpack_public_path__ + "img/zeigling3.9222a657.jpg";